/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["fieldset.stock-values-border[_ngcontent-%COMP%]{border:2px solid green!important;border-radius:10px!important;padding:5px!important;width:100%!important}legend.stock-values-border[_ngcontent-%COMP%]{width:auto!important;padding-left:10px!important;padding-right:10px!important;border:none!important;font-size:14px!important}"];
export { styles as styles };
